import React, { useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import { navigate } from "gatsby";

// Handle client-side redirects for specific paths
export const onRouteUpdate = ({ location }) => {
  const { pathname, search } = location;

  // Redirect /application to /apply with all query parameters
  if (pathname.startsWith("/application")) {
    // Don't redirect if we're already in the redirect component
    if (pathname === "/application" || pathname === "/application/") {
      return;
    }

    // For nested paths under /application
    const newPath = pathname.replace("/application", "/apply");
    navigate(newPath + search, { replace: true });
  }
};

export const wrapPageElement = ({ element }) => (
  <AnimatePresence mode="wait">{element}</AnimatePresence>
);
